
import _ from 'lodash';
import {setDefaults} from "@/router/helper";


// 工厂生产
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const inventoryList= () => import('@/views/goodsManage/inventoryList.vue');
const goodsPurchaseListPage= () => import('@/views/goodsManage/goodsPurchaseListPage.vue');
const goodsPurchaseDetail= () => import('@/views/goodsManage/goodsPurchaseDetail.vue');

const goodsInventoryDetail= () => import('@/views/goodsManage/goodsInventoryDetail.vue');

//这是打样，订单里的打样信息，和打样中心的打样。在内容上相近，

const routes = [
  {
    path: 'inventoryList',
    meta: {
      title: '库存管理',
    },
    component:inventoryList ,
  },{
    path: 'goodsPurchaseListPage',
    meta: {
      title: '库存采购',
    },
    component:goodsPurchaseListPage ,
  },
  {
    path: 'goodsPurchaseDetail/:id',
    meta: {
      title: '库存采购单',
    },
    component:goodsPurchaseDetail ,
  },
  {
    path: 'goodsInventoryDetail/:inventoryId',
    meta: {
      title: '库存记录',
    },
    component:goodsInventoryDetail ,
  }


];



export default setDefaults(routes);
